import { render, staticRenderFns } from "./VAST2022.md?vue&type=template&id=9e1bb0ee&"
import script from "./VAST2022.md?vue&type=script&lang=js&"
export * from "./VAST2022.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports